import React from 'react';

import { LG, MD, XSS } from '../../constants';
import { ColumnWrapper } from './styles';

class Col extends React.Component {
    constructor(props) {
        super(props);
        this.columnWidthCalculator = this.columnWidthCalculator.bind(this);
        this.state = {
            width: 0,
        };
    }

    componentDidMount() {
        this.columnWidthCalculator();
        window.addEventListener('resize', this.columnWidthCalculator);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.columnWidthCalculator);
    }

    columnWidthCalculator() {
        const w = window;
        const d = document;
        const e = document.documentElement;
        const g = d.getElementsByTagName('body')[0];
        const { mobile, desktop, cols, width } = this.props;
        const winWidth = w.innerWidth || e.clientWidth || g.clientWidth;

        if (!!mobile && winWidth >= XSS && winWidth <= MD) {
            return this.setState({
                width: mobile,
            });
        }
        if (!!desktop && winWidth > MD && winWidth <= LG) {
            return this.setState({
                width: desktop,
            });
        }
        return this.setState({
            width: (100 / cols) * width,
        });
    }

    orderCalculator() {
        const { order } = this.props;

        return order;
    }

    render() {
        const {
            children,
            alignCenter,
            flexDirectionColumn,
            justifyCenter,
            flex,
            summaryColumn,
        } = this.props;
        const { width } = this.state;

        const styling = {
            width: `${width}%`,
            order: this.orderCalculator(),
        };

        return (
            <ColumnWrapper
                flex={flex}
                alignCenter={alignCenter}
                flexDirectionColumn={flexDirectionColumn}
                justifyCenter={justifyCenter}
                summaryColumn={summaryColumn}
                style={styling}
            >
                {children}
            </ColumnWrapper>
        );
    }
}

export default Col;
